import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { Brand, PaginatedResponse } from '@app/utils/interfaces/brands.interface';
import { environment } from '@env/environment';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BrandsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  public getBrands(): Observable<Brand[]> {
    return this.http
      .get<{ data: { items: Brand[] } }>(`${this.baseUrl}${ApiEndpoints.GET_BRANDS}`)
      .pipe(map((res) => res?.data?.items || []));
  }

  public createBrand(name: string): Observable<Brand> {
    const form = new FormData();
    form.append('Name', name);

    return this.http
      .post<{ data: Brand }>(`${this.baseUrl}${ApiEndpoints.GET_BRANDS}`, form)
      .pipe(map((res) => res.data));
  }

  public getPaginatedBrands(page = 1, size = 10): Observable<PaginatedResponse<Brand>> {
    const params = new HttpParams().append('PageNumber', page).append('PageSize', size);

    return this.http.get<PaginatedResponse<Brand>>(`${this.baseUrl}${ApiEndpoints.GET_BRANDS}`, {
      params,
    });
  }

  public onCreateBrands(payload: FormData): Observable<Brand> {
    return this.http.post<Brand>(`${this.baseUrl}${ApiEndpoints.POST_BRANDS}`, payload)
  }

}
